import { ReactNode, useEffect, useId } from "react";
import { useCarousel } from "./hooks";
import styles from "./carousel-slide.module.css";
import uniq from "lodash/uniq";

export type CarouselSlideProps = {
  children: ReactNode;
  className?: string;
};

export function CarouselSlide({ children, className = "" }: CarouselSlideProps) {
  const { setSlides } = useCarousel();
  const id = useId();

  useEffect(() => {
    setSlides((slides: string[]) => uniq([...slides, id]));
  }, [id]);

  return <div className={`${styles.Container} ${className}`}>{children}</div>;
}
